import { Outlet } from "react-router-dom";
import NavbarContainer from "components/navbar";
import { useMemo } from "react";
import { useSharedState } from "state";

export default function NavbarLayout() {
  const { user } = useSharedState();

  const isShowingNav = useMemo(() => {
    return (!user.result.document_approval_access && window.location.pathname.includes("/documents")) ||
      (!user.result.payment_approval_access && window.location.pathname.includes("/payments")) ||
      (user.result.role !== "admin" && window.location.pathname.includes("/users")) ||
      (user.result.role !== "admin" && window.location.pathname.includes("/templates"))
      ? false
      : true;
  }, [user, window.location.pathname]);

  return (
    <div className="page">
      {isShowingNav && <NavbarContainer />}
      <Outlet />
    </div>
  );
}
